import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

import Layout from '../components/LayoutNext'
import Container from '../components/Layout/Container'

const NotFound = () => (
  <Layout>
    <Helmet>
      <title>Page Not Found | Gearflow</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <Container className="py-16">
      <div className="max-w-2xl mx-auto text-center">
        <h1 className="text-4xl lg:text-5xl text-center font-bold mb-8">Page Not Found</h1>
        <p className="text-gray-600 mb-12">
          Sorry, we couldn't find the page you're looking for. The page may have been moved,
          deleted, or you may have entered an incorrect URL.
        </p>
        <Link
          to="/"
          className="px-4 py-2 lg:py-3 text-sm lg:text-base text-center inline-block font-medium border shadow-base rounded-md lg:rounded-lg bg-orange-500 text-white border-orange-500"
        >
          Go to Homepage
        </Link>
      </div>
    </Container>
  </Layout>
)

export default NotFound
